import { createSyncRunner } from '../platform/sync-runner';
import { mdb, MORSE_TABLE_MAP } from './db';

/** The morse sync loop — the platform runner bound to this module's own store. */
export const morseSync = createSyncRunner({
  endpoint: '/api/v1/morse/sync',
  db: mdb,
  outbox: mdb.outbox,
  meta: mdb.meta,
  rejections: mdb.rejections,
  tables: MORSE_TABLE_MAP,
  sinceKey: 'morse_since',
  lastOkKey: 'morse_last_ok',
});

export const startMorseSync = () => morseSync.startLoop();
